module.exports = __webpack_public_path__ + "img/hillstone.c836d7d7.png";